export default __webpack_public_path__ + "static/media/doge-computer.2df6b108.webp";